import { IFailResponse } from '@/types';
import {
  verifyBusinessNumberApi,
  signupApi,
  verifyInterestExist,
  interestSubmitApi,
  verifyExistSignup
} from '../apis/signupApi';

export const businessNumberVerify = async (bizNo: string): Promise<boolean> => {
  const response = await verifyBusinessNumberApi(bizNo);
  if (response.isSuccess && response.data) {
    return true;
  } else {
    return false;
  }
};

export const signupAccount = async (
  data: any
): Promise<{ data: string; success: boolean; code?: string }> => {
  const response = await signupApi(data);
  if (response.isSuccess && response.data) {
    return { success: true, data: response.data };
  } else {
    if (
      (response as IFailResponse<string>).message === 'CIC_NO_INTEREST_EXIST'
    ) {
      return { success: false, code: 'no_interest_exist', data: '' };
    }
    if (
      (response as IFailResponse<string>).message ===
      'CIC_SALESFORCE_EMAIL_ALREADY_EXIST'
    ) {
      return { success: false, code: 'email_exist', data: '' };
    }
    return { success: false, data: '' };
  }
};

export const checkInterestExist = async (data: {
  email: string;
}): Promise<boolean> => {
  const response = await verifyInterestExist(data);
  if (response.isSuccess && response?.data) {
    return true;
  } else {
    return false;
  }
};

export const checkSignupExist = async (data: {
  email: string;
}): Promise<boolean> => {
  const response = await verifyExistSignup(data);
  if (response.isSuccess && response?.data) {
    return true;
  } else {
    return false;
  }
};

export const interestSubmit = async (
  data: any
): Promise<{ data: string; success: boolean; code?: string }> => {
  const response = await interestSubmitApi(data);
  if (response.isSuccess && response.data) {
    return { success: true, data: response.data };
  } else {
    if (
      (response as IFailResponse<string>).message ===
      'CIC_SALESFORCE_EMAIL_ALREADY_EXIST'
    ) {
      return { success: false, code: 'email_exist', data: '' };
    }
    return { success: false, data: '' };
  }
};
